<ng-container *ngIf="previewFiles.getPortal() | async as portal">
    <ng-template [cdkPortalOutlet]="portal" (attached)="test($event)"></ng-template>
</ng-container>